import { urlParamUtils } from '@/utils/storage/url-local-storage';

import { PLANNER_PREFERENCES_STORAGE_KEY } from './persisted-state';

/**
 * Imperatively clears the persisted filter values (localStorage entry + URL
 * params) BEFORE the store update lands. resetFilter needs this because the
 * persist middleware's own write races the URL cleanup: without the eager
 * cleanup a refresh in that window would re-hydrate the just-cleared filters.
 */
export const clearPersistedFilters = (filterKeys: string[]): void => {
  if (filterKeys.length === 0) return;

  try {
    const stored = localStorage.getItem(PLANNER_PREFERENCES_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      const state = parsed.state || parsed;
      state.filters = {};
      localStorage.setItem(PLANNER_PREFERENCES_STORAGE_KEY, JSON.stringify({ ...parsed, state }));
    }
  } catch {
    // Ignore parse errors — the persist middleware will rewrite the entry anyway.
  }

  urlParamUtils.deleteMultiple(filterKeys);
};
